
import { Stages } from './stageInfo';

const customerSSOStages = [Stages.production];
const lightHouseCustomerSSOStages = [Stages.production, Stages.prodtest];
const videojetSSOStages = [Stages.production, Stages.prodtest, Stages.dev];

export const SSOCustomers = [
  { domain: "@videojet.com", stages: videojetSSOStages, name: "Videojet-AD" },
  { domain: "@hillspet.com", stages: lightHouseCustomerSSOStages, name: "HillsPet" },
  { domain: "@colpal.com", stages: lightHouseCustomerSSOStages, name: "HillsPet" },
  { domain: "@masterpackaging.com", stages: lightHouseCustomerSSOStages, name: "MasterPackaging" },
  { domain: "@master-packaging.com", stages: lightHouseCustomerSSOStages, name: "MasterPackaging" },
  { domain: "@jdirving.com", stages: lightHouseCustomerSSOStages, name: "MasterPackaging" },
  { domain: "@tesla.com", stages: lightHouseCustomerSSOStages, name: "Tesla" },
];
